export const LANDING = '/';
export const BUY_SIGN_IN = '/buy/signin/:token';
export const SELL_SIGN_IN = 'sell/signin/:token';
export const CHECKOUT = '/checkout/:token';
export const DEMO = '/demo';
export const BUYER = '/buyer/:token'
export const SELLER_TOKEN = '/seller/:token'
export const SELLER = '/seller'
export const SELLERFLOW = '/sellerflow/:token'
